import _ from 'lodash'

export default class JsonObject {
  static name = 'JsonObject'

  static parse (value) {
    if (_.isString(value)) {
      return JSON.parse(value)
    } else {
      return value
    }
  }

  static encode (value) {
    if (!value) return value

    return JSON.stringify(value || {})
  }
}
